/* Feb-2026 · Mature-Audiences acceptance row for the ExecSummary
 * admin panel. Rolls up `/api/admin/content-warning/summary` into a
 * 4-stat mini-row (all-time · window · MA-only gate · top shelf).
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ShieldAlert } from 'lucide-react';

const API = (process.env.REACT_APP_BACKEND_URL || '') + '/api';
const http = axios.create({ baseURL: API, withCredentials: true });

function Stat({ label, value, testId, accent }) {
  return (
    <div
      className="rounded-md border bg-card p-3"
      data-testid={testId}
      style={accent ? { borderColor: '#c04a63', backgroundColor: '#c04a6314' } : undefined}
    >
      <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">{label}</div>
      <div className="mt-1 font-mono-stat text-lg font-semibold">{value}</div>
    </div>
  );
}

export default function MatureAudiencesAcceptancesRow({ days = 7 }) {
  const [data, setData] = useState(null);
  const [err,  setErr]  = useState(null);
  useEffect(() => {
    http.get(`/admin/content-warning/summary?days=${days}`)
      .then((r) => setData(r.data))
      .catch((e) => setErr(e?.response?.data?.detail || 'load failed'));
  }, [days]);

  if (err) {
    return (
      <div className="mt-3 rounded-md border border-destructive/40 bg-destructive/5 p-3 text-[11px] text-destructive">
        Content-warning summary unavailable: {err}
      </div>
    );
  }
  if (!data) {
    return (
      <div className="mt-3 h-[70px] animate-pulse rounded-md border bg-muted/40" />
    );
  }
  const top = (data.per_slug_window || [])[0];
  return (
    <section className="mt-6" data-testid="mature-audiences-acceptances-row">
      <div className="mb-2 flex items-center gap-2 text-[11px] uppercase tracking-[0.16em] text-muted-foreground">
        <ShieldAlert className="h-3 w-3" /> Mature Audiences · content-warning acceptances
        <span className="ml-auto text-[10px] normal-case tracking-normal">(last {data.window_days} d)</span>
      </div>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
        <Stat label="All-time acceptances" value={(data.total_all_time || 0).toLocaleString()}
              testId="ma-stat-all-time" />
        <Stat label={`Any shelf (${data.window_days}d)`} value={(data.total_window || 0).toLocaleString()}
              testId="ma-stat-window" />
        <Stat label="Mature-Audiences gate" value={(data.adults_only_window || 0).toLocaleString()}
              testId="ma-stat-mature-gate" accent />
        <Stat label="Top shelf"
              value={top ? `${top.slug} · ${top.count.toLocaleString()}` : '—'}
              testId="ma-stat-top-shelf" />
      </div>
    </section>
  );
}
